import { useState, useCallback } from 'react';
import { preferencesService } from '../../services/api';
import { userKey } from '../../utils/userStorage';

const STORAGE_KEY = 'nizus_dashboard_prefs';

function readFavorites() {
    try {
        const raw = localStorage.getItem(userKey(STORAGE_KEY));
        if (!raw) return { exams: [], courses: [] };
        const prefs = JSON.parse(raw);
        return {
            exams: Array.isArray(prefs.favoriteExams) ? prefs.favoriteExams : [],
            courses: Array.isArray(prefs.favoriteCourses) ? prefs.favoriteCourses : [],
        };
    } catch {
        return { exams: [], courses: [] };
    }
}

function writeFavorites(exams, courses) {
    try {
        const raw = localStorage.getItem(userKey(STORAGE_KEY));
        const prefs = raw ? JSON.parse(raw) : {};
        prefs.favoriteExams = exams;
        prefs.favoriteCourses = courses;
        localStorage.setItem(userKey(STORAGE_KEY), JSON.stringify(prefs));
    } catch { /* quota exceeded or private browsing */ }
    preferencesService.save({ favoriteExams: exams, favoriteCourses: courses }).catch(() => {});
}

export default function useFavorites() {
    const [favorites, setFavorites] = useState(readFavorites);

    const toggleFavoriteExam = useCallback((examId) => {
        setFavorites(prev => {
            const id = Number(examId);
            const exams = prev.exams.includes(id)
                ? prev.exams.filter(e => e !== id)
                : [...prev.exams, id];
            const next = { ...prev, exams };
            writeFavorites(next.exams, next.courses);
            return next;
        });
    }, []);

    const toggleFavoriteCourse = useCallback((courseId) => {
        setFavorites(prev => {
            const id = Number(courseId);
            const courses = prev.courses.includes(id)
                ? prev.courses.filter(c => c !== id)
                : [...prev.courses, id];
            const next = { ...prev, courses };
            writeFavorites(next.exams, next.courses);
            return next;
        });
    }, []);

    const isFavoriteExam = useCallback((examId) => {
        return favorites.exams.includes(Number(examId));
    }, [favorites.exams]);

    const isFavoriteCourse = useCallback((courseId) => {
        return favorites.courses.includes(Number(courseId));
    }, [favorites.courses]);

    return { favorites, toggleFavoriteExam, toggleFavoriteCourse, isFavoriteExam, isFavoriteCourse };
}
